import { Group, Switch, Table, Tooltip } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { AuthorityResponse } from 'types';

import classes from './PermissionsPage.module.css';

interface PermissionRowProps {
  permission: AuthorityResponse;
  isEnabled: boolean;
  rowBg: string;
  onChange: (code: string, checked: boolean) => void;
}

const PermissionRow = ({ permission, isEnabled, rowBg, onChange }: PermissionRowProps) => {
  const { t, i18n } = useTranslation();

  const permissionCode = permission.code || permission.name || '';
  const descriptionKey = `permissions.descriptions.${permissionCode}`;
  const description = i18n.exists(descriptionKey) ? t(descriptionKey) : undefined;

  return (
    <Table.Tr key={permissionCode}>
      <Table.Td className={classes.permissionCell} style={{ backgroundColor: rowBg }}>
        <Group gap="xs" wrap="nowrap" align="center">
          <span>{permission.description || permissionCode}</span>
          {description && (
            <Tooltip label={description} withArrow multiline w={280} position="right">
              <IconInfoCircle
                size={16}
                style={{ cursor: 'help', flexShrink: 0, opacity: 0.6 }}
              />
            </Tooltip>
          )}
        </Group>
      </Table.Td>
      <Table.Td style={{ width: 100, textAlign: 'right', backgroundColor: rowBg }}>
        <Switch
          checked={isEnabled}
          onChange={(event) => onChange(permissionCode, event.currentTarget.checked)}
          styles={{ track: { cursor: 'pointer' }, thumb: { cursor: 'pointer' } }}
        />
      </Table.Td>
    </Table.Tr>
  );
};

export default PermissionRow;
